import { requireAuth } from '@/router/helpers';

/**
 * FE routes
 */
const FeRoutes = [
  /**
   * Admin routes
   */
];

const AdminRoutes = [
  {
    path: '/admin/news/categories',
    name: 'AdminNewsCategoriesIndexPage',
    component: () => import('@/views/news/admin/categories/Index'),
    beforeEnter: requireAuth,
    meta: {
      isAdmin: true,
    },
  },
  {
    path: '/admin/news/categories/create',
    name: 'AdminNewsCategoryCreate',
    components: {
      default: () => import('@/views/news/admin/categories/Index'),
      panel: () => import('@/views/news/admin/categories/CategoryEditCreate'),
    },
    beforeEnter: requireAuth,
    meta: {
      openPanel: true,
      isAdmin: true,
    },
  },
  {
    path: '/admin/news/categories/edit/:id',
    name: 'AdminNewsCategoryEdit',
    components: {
      default: () => import('@/views/news/admin/categories/Index'),
      panel: () => import('@/views/news/admin/categories/CategoryEditCreate'),
    },
    beforeEnter: requireAuth,
    meta: {
      openPanel: true,
      isAdmin: true,
    },
  },
];

export default [...FeRoutes,...AdminRoutes];
